<template>
  <input
    type="text"
    :value="value"
    @keypress="handleKeyDown"
    @input="handleInput"
    @blur="$emit('blur')">
</template>
<script>
import rutHelper from '@/helpers/rut';

export default {
  name: 'AppRutInput',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleKeyDown(event) {
      const key = event.key.toLowerCase();
      if (key.match(/\D/g) && key !== 'k') {
        event.preventDefault();
      }
    },
    handleInput(event) {
      this.$emit('input', rutHelper.format(event.target.value));
    }
  }
};
</script>
